import { AdminController as controller } from './admin.controller';
import template from './admin.html';
import '../../common/ui/componentHeader/componentHeader';

export const adminComponent = {
  name: 'adminComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<'
  }
};
